import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { VerifyPkRegistrationArgs } from '../../dto';

type Result = { verifyPkRegistration: boolean };
export const useVerifyPkRegistration = (options?: MutationHookOptions<Result, VerifyPkRegistrationArgs>) => {
  const mutation = gql`
    mutation verifyPkRegistration($input: VerifyPkRegistrationInput!) {
      verifyPkRegistration(input: $input)
    }
  `;

  return useMutation<Result, VerifyPkRegistrationArgs>(mutation, options);
};

export default useVerifyPkRegistration;

